import { useTranslation } from 'react-i18next'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import type { SurveyTemplateRow } from '../../common/types'
import { TRANSLATION_PREFIX } from '../../constants'

interface IProps {
  row: SurveyTemplateRow
  processing: boolean
  onConfirm: () => void
  onClose: () => void
}

/** Asks before archiving a survey of the bank. */
export const ArchiveConfirmation = ({
  row,
  processing,
  onConfirm,
  onClose,
}: IProps) => {
  const { t } = useTranslation()
  const prefix = `${TRANSLATION_PREFIX}.archive`

  return (
    <Modal
      title={t(`${prefix}.title`)}
      close={onClose}
      isConfirmation
      maxwidth={480}
      maxheight={320}
      roboto
      actions={
        <ModalButtons
          secondaryText={t(`${prefix}.cancel`)}
          secondaryAction={onClose}
          primaryText={t(`${prefix}.confirm`)}
          primaryAction={onConfirm}
          processing={processing}
        />
      }
    >
      <p data-testid="survey-bank-archive-message">
        {t(`${prefix}.notice`, { name: row.name })}
      </p>
    </Modal>
  )
}
